"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const events_1 = require("../../../../constants/events");
const userQuery_1 = require("../../../../queries/userQuery");
const dateUtils_1 = require("../../../../utils/dateUtils");
const zustandStore_1 = require("../../../../zustandStore");
const purchaseRequestForm_1 = __importDefault(require("../newRequest/purchaseRequestForm"));
const requestDetail_1 = __importDefault(require("../newRequest/requestDetail"));
const virtualCard_1 = __importDefault(require("../virtualCard"));
const lexico = new lexico_1.default();
const StyledTypography = (0, material_1.styled)(material_1.Typography)(ownerState => {
    const { 'ts-variant': tsVariant, theme } = ownerState;
    return {
        fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.default),
        fontWeight: theme.typography.tsFontWeight.default,
        wordBreak: 'break-word',
        ...(tsVariant === 'italic' && {
            fontStyle: 'italic',
        }),
        ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
            ? {
                fontWeight: 400,
                color: '#000000',
            }
            : {}),
    };
});
const getMessage = ({ event, allEvents, currentUser, }) => {
    switch (event.type) {
        case events_1.events.types.purchases.requestCreated: {
            return ((0, jsx_runtime_1.jsx)(StyledTypography, { children: lexico.trc('automated message for a new request created', 'Just let me know what this card is for, and I will send it for approval.') }));
        }
        case events_1.events.types.purchases.requestForm: {
            return allEvents?.find(ev => ev.type === events_1.events.types.purchases.requestSubmitted) ? ((0, jsx_runtime_1.jsx)(StyledTypography, { "ts-variant": "italic", children: lexico.trc('automated message for a new request submitted', 'Request created.') })) : ((0, jsx_runtime_1.jsx)(purchaseRequestForm_1.default, {}));
        }
        case events_1.events.types.purchases.managerNotified: {
            const managerFullName = event.manager?.fullName || lexico.tr('your manager');
            // TODO: use lexico after project integration
            return ((0, jsx_runtime_1.jsx)(StyledTypography, { children: `Great! I just let ${managerFullName} know. Your card will be ready once it is approved.` }));
        }
        case events_1.events.types.messageAdded: {
            return typeof event.data.body === 'string' && (0, jsx_runtime_1.jsx)(StyledTypography, { children: event.data.body });
        }
        case events_1.events.types.purchases.requestSubmitted: {
            return (0, jsx_runtime_1.jsx)(requestDetail_1.default, {});
        }
        case events_1.events.types.purchases.requestChanged: {
            const isDate = event.data.body?.data.property === 'enddate';
            return ((0, jsx_runtime_1.jsxs)(StyledTypography, { "ts-variant": "italic", children: ["Changed the ", isDate ? 'end date' : event.data.body?.data.property, event.data.body?.data.oldValue && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [' ', "from", ' ', isDate
                                ? (0, dateUtils_1.formatDate)(event.data.body?.data.oldValue, currentUser?.language)
                                : event.data.body?.data.oldValue] })), ' ', "to", ' ', isDate ? (0, dateUtils_1.formatDate)(event.data.body?.data.newValue, currentUser?.language) : event.data.body?.data.newValue, "."] }));
        }
        case events_1.events.types.purchases.requestApproved: {
            return (0, jsx_runtime_1.jsx)(StyledTypography, { "ts-variant": "italic", children: "Marked as approved" });
        }
        case events_1.events.types.purchases.requestRejected: {
            return (0, jsx_runtime_1.jsx)(StyledTypography, { "ts-variant": "italic", children: "Marked as declined" });
        }
        case events_1.events.types.purchases.requestReassigned: {
            return ((0, jsx_runtime_1.jsxs)(StyledTypography, { children: ["Request forwarded to ", (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "span", children: event.reassignedTo?.fullName }), event.data.body?.data.reason && ((0, jsx_runtime_1.jsxs)(material_1.Typography, { component: "div", children: [(0, jsx_runtime_1.jsx)("br", {}), " Reason: ", (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "span", children: event.data.body?.data.reason }), "."] }))] }));
        }
        case events_1.events.types.purchases.virtualCardAdded: {
            return (0, jsx_runtime_1.jsx)(virtualCard_1.default, { event: event });
        }
        default: {
            return event.type;
        }
    }
};
const Message = ({ event }) => {
    const { data: currentUser } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const allEvents = (0, zustandStore_1.useZustand)(state => state.request.allEvents);
    const message = getMessage({ event, allEvents, currentUser });
    return message || null;
};
exports.default = Message;
